export default __webpack_public_path__ + "static/media/check-orange.87068622.svg";